export const onstreetDeliveryInfoWindowSelector = ({onstreetDeliveryInfoWindow}) => onstreetDeliveryInfoWindow